<template>
  <div>
    <!-- Conteúdo invisível que será convertido em PDF -->
    <div
      :id="pdfContentId"
      ref="pdfContent"
      :data-pdf-content="pdfContentId"
      style="position: absolute; left: -9999px; width: 794px; padding: 20px; background: white; font-family: Arial, sans-serif; font-size: 14px; line-height: 1.4; color: #000000 !important;"
      v-html="relatorioSelecionado"
    />

    <!-- Botão de ação único -->
    <div>
      <v-tooltip location="top">
        <template #activator="{ props }">
          <v-btn
            v-bind="{ ...props, ...buttonProps }"
            :icon="!buttonText"
            :loading="loadDownload"
            :disabled="loadDownload"
            @click="handleImpressao()"
          >
            <v-icon
              v-if="!buttonText || showButtonIcon"
              :start="!!buttonText"
            >
              {{ getIcon() }}
            </v-icon>
            <span v-if="buttonText">{{ buttonText }}</span>
          </v-btn>
        </template>
        <span>{{ getTooltipText() }}</span>
      </v-tooltip>
    </div>

    <!-- Dialog de Confirmação para Solicitações -->
    <v-dialog
      v-if="isSolicitacaoType"
      v-model="showConfirmDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="headline">
          <v-icon left>
            print
          </v-icon>
          Imprimir Solicitação
        </v-card-title>
        <v-card-text>
          <p>Deseja imprimir a solicitação de exames?</p>
          <v-alert
            type="info"
            density="compact"
            class="mt-3"
          >
            <small>Esta solicitação será aberta no visualizador de PDF.</small>
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            @click="showConfirmDialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="loadDownload"
            @click="confirmarImpressao()"
          >
            <v-icon left>
              visibility
            </v-icon>
            Visualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Visualizador de PDF (para receitas, relatórios E solicitações) -->
    <v-dialog
      v-if="isVisualizadorType"
      v-model="showPdfViewer"
      max-width="90%"
      persistent
    >
      <v-card>
        <v-card-title class="headline d-flex align-center">
          <div class="d-flex align-center">
            <v-icon class="mr-2">
              picture_as_pdf
            </v-icon>
            Visualizador de {{ getTitulo() }}
          </div>
          <v-spacer />
          <v-btn
            icon
            color="error"
            @click="fecharVisualizador"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div
            v-if="!pdfSource"
            class="text-center py-10"
          >
            <v-progress-circular
              indeterminate
              color="primary"
            />
            <div class="mt-3">
              Carregando PDF...
            </div>
          </div>
          <div v-else>
            <object
              :data="pdfSource"
              type="application/pdf"
              width="100%"
              height="600px"
              style="border: none;"
            >
              <p>
                Seu navegador bloqueou a visualização.
              </p>
            </object>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar para mensagens -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      timeout="3000"
    >
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import medicoService from "../../../services/medico.service";

export default {
  name: "PrintPreview",
  props: {
    mFicha: { 
      type: Object, 
      required: true,
      default: () => ({
        nomePaciente: "",
        idOrdemServico: "",
        idAtendimento: "",
        idPaciente: ""
      })
    },
    dataCadastro: { 
      type: String, 
      default: "" 
    },
    dataHabilitada: {
      type: Boolean,
      default: null
    },
    user: { 
      type: Object, 
      required: true,
      default: () => ({
        idEmpresa: 1,
        nome: "",
        siglaConselho: "",
        ufConselho: "",
        crm: "",
        id: "",
        idPrestador: ""
      })
    },
    medicamentos: { 
      type: Array, 
      default: () => [] 
    },
    itemsImpressao: {
      type: Array,
      default: () => []
    },
    receita: {
      type: Object,
      default: null
    },
    descricao: { 
      type: String, 
      default: "" 
    },
    observacao: {
      type: String,
      default: ""
    },
    tipoImpressao: {
      type: String, 
      default: "receita",
      validator: (value) => ["receita", "solicitacao", "solicitacao-laboratorio", "relatorio", "laudo"].includes(value)
    },
    relatorio: {
      type: Object,
      default: null
    },
    solicitacao: {
      type: Object,
      default: null
    },
    consulta: {
      type: Object,
      default: null
    },
    idapicfmEspecializacao: {
      type: [Number, String],
      default: null
    },
    modo: {
      type: String,
      default: "impressao",
      validator: (value) => ["impressao", "visualizacao"].includes(value)
    },
    tipo: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    buttonProps: {
      type: Object,
      default: () => ({ color: "blue", icon: true })
    },
    showButtonIcon: {
      type: Boolean,
      default: true
    },
    modoLote: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pdfContentId: `pdf-content-${Math.random().toString(36).slice(2, 10)}`,
      relatorioSelecionado: "",
      loadDownload: false,
      pdfBlob: null,
      pdfSource: null,
      pdfDownloadUrl: null,
      showPdfViewer: false,
      showConfirmDialog: false,
      page: 1,
      receitas: [],
      snackbar: {
        show: false,
        message: "",
        color: "success"
      }
    };
  },
  computed: {
    hasBatchItems() {
      return this.modoLote && Array.isArray(this.itemsImpressao) && this.itemsImpressao.length > 0;
    },
    tipoDocumento() {
      const tipos = {
        'receita': 'solicitacaoReceita',
        'solicitacao': 'solicitacaoExames',
        'solicitacao-laboratorio': 'solicitacaoExames',
        'relatorio': 'solicitacaoRelatorio',
        'laudo': 'laudo'
      };
      return tipos[this.tipoImpressao] || 'solicitacaoReceita';
    },
    
    tituloDocumento() {
      const titulos = {
        'receita': 'RECEITA MÉDICA',
        'solicitacao': 'SOLICITAÇÃO DE EXAMES',
        'solicitacao-laboratorio': 'SOLICITAÇÃO DE LABORATÓRIO',
        'relatorio': 'RELATÓRIO MÉDICO',
        'laudo': 'LAUDO MÉDICO'
      };
      return titulos[this.tipoImpressao] || 'DOCUMENTO';
    },

    // Identifica se é um tipo de solicitação que precisa de confirmação
    isSolicitacaoType() {
      return this.tipoImpressao === 'solicitacao' || this.tipoImpressao === 'solicitacao-laboratorio';
    },

    // Identifica se é um tipo que abre visualizador (AGORA INCLUI SOLICITAÇÕES)
    isVisualizadorType() {
      return this.tipoImpressao === 'receita' || 
             this.tipoImpressao === 'relatorio' || 
             this.tipoImpressao === 'solicitacao' || 
             this.tipoImpressao === 'solicitacao-laboratorio' ||
             this.tipoImpressao === 'laudo';
    },

    dataExibirValue() {
      if (!this.isDataHabilitada()) return '';
      return this.formatDatePtBr(this.dataCadastro) || '';
    }
  },
  watch: {
    descricao: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.tipoImpressao === 'receita') {
          this.relatorioSelecionado = this.formatarConteudoReceita(newVal);
        }
      }
    },
    
    tipoImpressao: {
      immediate: true,
      handler() {
        this.prepararConteudoPorTipo();
      }
    },

    relatorio: {
      deep: true,
      handler(newVal) {
        if (newVal && this.tipoImpressao === 'relatorio') {
          this.prepararConteudoRelatorio(newVal);
        }
      }
    },

    consulta: {
      deep: true,
      handler(newVal) {
        if (newVal && this.tipoImpressao === 'laudo') {
          this.prepararConteudoLaudo(newVal);
        }
      }
    }
  },
  mounted() {
    this.prepararConteudoPorTipo();
  },
  beforeUnmount() {
    if (this.pdfDownloadUrl) {
      URL.revokeObjectURL(this.pdfDownloadUrl);
    }
  },
  methods: {
    // Método principal que decide o comportamento baseado no tipo
    handleImpressao() {
      if (this.isSolicitacaoType) {
        // Para solicitações: mostrar dialog de confirmação
        this.confirmarImpressao()
      } else if (this.isVisualizadorType) {
        // Para receitas, relatórios e solicitações: abrir visualizador diretamente
        this.imprimir();
      } else {
        // Para outros tipos (apenas laudos): imprimir diretamente
        this.imprimir();
      }
    },

    // Confirmação de impressão para solicitações
    confirmarImpressao() {
      this.showConfirmDialog = false;
      this.imprimir();
    },

    // Método principal de impressão
    async imprimir() {
      try {
        this.loadDownload = true;
        this.showMessage(`Gerando ${this.getTitulo()}...`, "info");
        
        // Para relatórios e receitas, sempre usar o novo fluxo
        if (this.tipoImpressao === 'relatorio') {
          if (this.hasBatchItems) {
            await this.gerarRelatoriosEmLote();
            return;
          }
          await this.gerarComHtml2Canvas();
          return;
        }

        if (this.tipoImpressao === 'receita') {
          if (this.hasBatchItems) {
            await this.gerarReceitasEmLote();
            return;
          }
          await this.gerarComHtml2Canvas();
          return;
        }

        if (this.tipoImpressao === 'solicitacao' || this.tipoImpressao === 'solicitacao-laboratorio') {
          if (this.hasBatchItems) {
            await this.gerarSolicitacoesEmLote();
            return;
          }
          await this.gerarComHtml2Canvas();
          return;
        }

        if (this.tipoImpressao === 'laudo' && this.consulta && this.consulta.idexamesos) {
          await this.gerarLaudoEspecifico();
          return;
        }

        // Para solicitações e outros, usar o método com html2canvas
        await this.gerarComHtml2Canvas();
        
      } catch (error) {
        console.error(`Erro ao gerar ${this.tipoImpressao}:`, error);
        this.showMessage(`Erro ao gerar ${this.tipoImpressao}: ${error.message}`, "error");
      } finally {
        this.loadDownload = false;
      }
    },

    getIcon() {
      if (this.hasBatchItems && (this.tipoImpressao === 'receita' || this.tipoImpressao === 'relatorio' || this.isSolicitacaoType)) {
        return 'print';
      }
      const icons = {
        'receita': 'visibility',
        'solicitacao': 'visibility',
        'solicitacao-laboratorio': 'visibility',
        'relatorio': 'visibility',
        'laudo': 'description'
      };
      return icons[this.tipoImpressao] || 'print';
    },

    getIdExamesOS() {
      return this.consulta?.idexamesos ||
        this.consulta?.idExamesOS ||
        this.mFicha?.idexamesos ||
        this.mFicha?.idExamesOS ||
        null;
    },

    getMedicoId() {
      return this.user?.id || this.$store?.getters?.usuario?.id || null;
    },

    formatDatePtBr(value) {
      if (!value) return '';
      if (value instanceof Date && !Number.isNaN(value.getTime())) {
        const d = String(value.getDate()).padStart(2, '0');
        const m = String(value.getMonth() + 1).padStart(2, '0');
        const y = String(value.getFullYear());
        return `${d}/${m}/${y}`;
      }
      if (typeof value === 'string') {
        const cleanValue = value.split('T')[0].split(' ')[0];
        if (value.includes('/')) {
          const [d, m, y] = cleanValue.split('/');
          if (d && m && y) return `${d}/${m}/${y}`;
        }
        if (cleanValue.includes('-')) {
          const [y, m, d] = cleanValue.split('-');
          if (y && m && d) return `${d}/${m}/${y}`;
        }
      }
      return '';
    },

    getDataExibirFallback(value) {
      if (!this.isDataHabilitada()) return '';
      if (value) return value;
      const now = new Date();
      const d = String(now.getDate()).padStart(2, '0');
      const m = String(now.getMonth() + 1).padStart(2, '0');
      const y = String(now.getFullYear());
      return `${d}/${m}/${y}`;
    },

    isDataHabilitada() {
      if (typeof this.dataHabilitada === 'boolean') return this.dataHabilitada;
      if (this.tipoImpressao === 'receita' && this.receita) {
        if (this.receita.dataHabilitada === false) return false;
        if (Object.prototype.hasOwnProperty.call(this.receita, 'dataSelecionada') && this.receita.dataSelecionada == null) {
          return false;
        }
      }
      if ((this.tipoImpressao === 'solicitacao' || this.tipoImpressao === 'solicitacao-laboratorio') && this.solicitacao) {
        if (this.solicitacao.dataHabilitada === false) return false;
        if (Object.prototype.hasOwnProperty.call(this.solicitacao, 'dataISO') && this.solicitacao.dataISO == null) {
          return false;
        }
      }
      return true;
    },

    getTooltipText() {
      const textos = {
        'receita': 'Visualizar receita',
        'solicitacao': 'Visualizar solicitação',
        'solicitacao-laboratorio': 'Visualizar solicitação de laboratório',
        'relatorio': 'Visualizar relatório',
        'laudo': 'Imprimir laudo'
      };
      if (this.hasBatchItems && this.tipoImpressao === 'receita') {
        return 'Imprimir todas as receitas';
      }
      if (this.hasBatchItems && this.tipoImpressao === 'relatorio') {
        return 'Imprimir todos os relatórios';
      }
      if (this.hasBatchItems && this.isSolicitacaoType) {
        return 'Imprimir todas as solicitações';
      }
      return textos[this.tipoImpressao] || 'Imprimir documento';
    },

    getTitulo() {
      const titulos = {
        'receita': 'Receita Médica',
        'solicitacao': 'Solicitação de Exames',
        'solicitacao-laboratorio': 'Solicitação de Laboratório',
        'relatorio': 'Relatório Médico',
        'laudo': 'Laudo Médico'
      };
      return titulos[this.tipoImpressao] || 'Documento';
    },

    prepararConteudoPorTipo() {
      switch (this.tipoImpressao) {
        case 'receita':
          this.relatorioSelecionado = this.formatarConteudoReceita(this.descricao);
          break;
        case 'solicitacao':
        case 'solicitacao-laboratorio':
          this.relatorioSelecionado = this.formatarConteudoSolicitacao();
          break;
        case 'relatorio':
          if (this.relatorio) {
            this.prepararConteudoRelatorio(this.relatorio);
          }
          break;
        case 'laudo':
          if (this.consulta) {
            this.prepararConteudoLaudo(this.consulta);
          }
          break;
      }
    },

    prepararConteudoRelatorio(relatorio) {
      this.relatorioSelecionado = this.formatarConteudoReceita(
        relatorio.descricao || relatorio.conteudo || 'Relatório sem conteúdo'
      );
    },

    prepararConteudoLaudo(consulta) {
      this.relatorioSelecionado = this.formatarConteudoReceita(
        consulta.laudo || 'Laudo não disponível'
      );
    },

    formatarConteudoReceita(conteudo) {
      if (!conteudo) {
        return `
          <div style="
            color: #000000 !important; 
            font-family: Arial, sans-serif !important; 
            font-size: 16px !important; 
            line-height: 1.6 !important;
            background: white !important;
          ">
            Nenhum conteúdo disponível para impressão
          </div>
        `;
      }
      
      if (!conteudo.includes('<')) {
        return `
          <div style="
            color: #000000 !important;
            font-family: Arial, sans-serif !important;
            font-size: 16px !important;
            line-height: 1.6 !important;
            background: white !important;
            padding: 20px;
          ">
            <h3 style="
              text-align: center; 
              margin-bottom: 20px; 
              color: #000000 !important;
              font-weight: bold !important;
              font-size: 20px !important;
            ">
              ${this.tituloDocumento}
            </h3>
            <div style="
              white-space: pre-line; 
              color: #000000 !important;
              font-weight: normal !important;
              font-size: 16px !important;
            ">
              ${conteudo}
            </div>
          </div>
        `;
      }
      
      return `
        <div style="
          color: #000000 !important;
          font-family: Arial, sans-serif !important;
          font-size: 16px !important;
          background: white !important;
          padding: 20px;
        ">
          <div style="color: inherit !important; font-size: inherit !important;">
            ${conteudo}
          </div>
        </div>
      `;
    },

    formatarConteudoSolicitacao() {
      const items = this.medicamentos || [];
      const observacao = this.observacao || '';
      
      let html = `
        <div style="
          color: #000000 !important;
          font-family: Arial, sans-serif !important;
          font-size: 16px !important;
          background: white !important;
          padding: 20px;
        ">
          <h3 style="
            text-align: center; 
            margin-bottom: 20px; 
            color: #000000 !important;
            font-weight: bold !important;
            font-size: 20px !important;
          ">
            ${this.tituloDocumento}
          </h3>
          <div style="margin-bottom: 20px;">
            <strong>Paciente:</strong> ${this.mFicha.nomePaciente || 'Não informado'}<br>
            <strong>Médico:</strong> Dr(a). ${this.user.nome || 'Não informado'}<br>
            <strong>Data:</strong> ${this.formatarData(this.dataCadastro)}
          </div>
      `;

      if (items.length > 0) {
        html += `
          <div style="margin-bottom: 20px;">
            <strong>Exames solicitados:</strong>
            <ol style="margin-left: 20px; margin-top: 10px;">
        `;
        
        items.forEach(item => {
          html += `<li style="margin-bottom: 8px;">${item.nome || item.apelido || 'Exame'}</li>`;
        });
        
        html += `
            </ol>
          </div>
        `;
      }

      if (observacao) {
        html += `
          <div style="margin-bottom: 20px;">
            <strong>Observações:</strong><br>
            <div style="white-space: pre-line; margin-top: 10px; padding: 10px; background: #f5f5f5; border-radius: 4px;">
              ${observacao}
            </div>
          </div>
        `;
      }

      html += `</div>`;
      return html;
    },

    async gerarLaudoEspecifico() {
      try {
        // Usar o método downloadLaudo do serviço médico
        const response = await medicoService.medico.downloadLaudo(this.consulta.idexamesos);
        await this.prepararVisualizacaoPdf(response.data);
      } catch (error) {
        console.error('Erro ao baixar laudo específico:', error);
        // Fallback para o método genérico
        await this.gerarComHtml2Canvas();
      }
    },

    async gerarRelatorioEspecifico() {
      try {
        const dataExibir = this.getDataExibirFallback(
          this.dataExibirValue ||
          this.formatDatePtBr(this.relatorio?.dataCadastro || this.relatorio?.data)
        );
        const payload = {
          idRelatorio: this.relatorio.id,
          data_exibir: dataExibir
        };
        payload.idapicfm_especializacao = this.idapicfmEspecializacao ?? this.relatorio?.idapicfm_especializacao ?? 0;

        const reportPayload = { ...payload, report: 'relatoriosmv2', reportType: 'pdf' };
        console.log('[printPreview] POST /smi/reports/get (relatoriosmv2) payload:', reportPayload);
        const response = await medicoService.medico.downloadReport(reportPayload);
        await this.prepararVisualizacaoPdf(response.data);
      } catch (error) {
        console.error('Erro ao baixar relatório específico:', error);
        throw error;
      }
    },

    async gerarRelatoriosEmLote() {
      try {
        if (!this.hasBatchItems) {
          throw new Error('Nenhum relatório disponível para impressão.')
        }
        const payload = { items: this.itemsImpressao }
        console.log('[printPreview] POST /smi/reports/get (relatoriosmv2) payload:', payload)
        const response = await medicoService.medico.downloadRelatorioMv2(payload);
        await this.prepararVisualizacaoPdf(response.data);
      } catch (error) {
        console.error('Erro ao baixar relatórios em lote:', error);
        throw error;
      }
    },

    async gerarReceitaEspecifica() {
      try {
        const dataExibir = this.getDataExibirFallback(
          this.dataExibirValue ||
          this.formatDatePtBr(
            this.receita?.dataSelecionada ||
            this.receita?.dataPrescricao ||
            this.receita?.dataReceita ||
            this.receita?.dataCadastro ||
            this.receita?.data
          )
        );
        const payload = {
          idReceitaMedica: this.receita.idReceitaMedica,
          data_exibir: dataExibir
        };
        payload.idapicfm_especializacao = this.idapicfmEspecializacao ?? this.receita?.idapicfm_especializacao ?? 0;

        const reportPayload = { ...payload, report: 'receitasmv2', reportType: 'pdf' };
        console.log('[printPreview] POST /smi/reports/get (receitasmv2) payload:', reportPayload);
        const response = await medicoService.medico.downloadReport(reportPayload);
        await this.prepararVisualizacaoPdf(response.data);
      } catch (error) {
        console.error('Erro ao baixar receita específica:', error);
        throw error;
      }
    },

    async gerarReceitasEmLote() {
      try {
        if (!this.hasBatchItems) {
          throw new Error('Nenhuma receita disponível para impressão.')
        }
        const payload = { items: this.itemsImpressao }
        console.log('[printPreview] POST /smi/reports/get (receitasmv2) payload:', payload)
        const response = await medicoService.medico.downloadReceitaMv2(payload);
        await this.prepararVisualizacaoPdf(response.data);
      } catch (error) {
        console.error('Erro ao baixar receitas em lote:', error);
        throw error;
      }
    },
    
    async gerarSolicitacoesEmLote() {
      try {
        if (!this.hasBatchItems) {
          throw new Error('Nenhuma solicitação disponível para impressão.')
        }
        const items = (this.itemsImpressao || []).map((item) => {
          const dataExibir = item?.dataHabilitada === false
            ? ''
            : (item?.data_exibir || this.getDataExibirFallback(
              this.formatDatePtBr(
                item?.dataISO ||
                item?.dataSelecionada ||
                item?.dataCadastro ||
                item?.data
              )
            ));
          return {
            idSolicitacao: item?.idSolicitacao,
            idapicfm_especializacao: this.idapicfmEspecializacao ?? item?.idapicfm_especializacao ?? 0,
            data_exibir: dataExibir
          };
        }).map((item) => {
          Object.keys(item).forEach((key) => {
            if (item[key] === undefined) {
              delete item[key];
            }
          });
          return item;
        }).filter((item) => item.idSolicitacao);
        const payload = { items };
        console.log('[printPreview] POST /smv2/solicitacaosmv2 payload:', payload)
        const response = await medicoService.medico.downloadSolicitacaoMv2(payload);
        await this.prepararVisualizacaoPdf(response.data);
      } catch (error) {
        console.error('Erro ao baixar solicitações em lote:', error);
        throw error;
      }
    },

    async generateReportRelatorio(data) {
      try {
        this.relatorioSelecionado = data.descricao;
        this.loadDownload = true;
        
        // Pré-processamento - Ajustar layout para landscape
        const element = this.$refs.pdfContent;
        if (!element) {
          throw new Error("Elemento pdf-content não encontrado no DOM");
        }
        element.style.width = '297mm';
        element.style.height = 'auto';
        element.style.overflow = 'visible';
        element.style.padding = '15mm';

        // Geração da imagem de preview
        const canvas = await html2canvas(element, {
          scale: 2,
          windowWidth: 1123,
          width: 1123,
          height: element.scrollHeight,
          useCORS: true,
          letterRendering: true,
          logging: false,
          backgroundColor: '#FFFFFF'
        });

        const imageBase64 = canvas.toDataURL('image/jpeg', 1.0);
        const base64Pure = imageBase64.split(',')[1];

        // Configura cabeçalho/rodapé
        let cabecalhoImg, rodapeImg;
        switch (this.user.idEmpresa) {
          case 4:
            cabecalhoImg = "cabe_cmr_receita.png";
            rodapeImg = "rodape_cmr.png";
            break;
          case 1:
            cabecalhoImg = "cabe_vit_receita.png";
            rodapeImg = "rodape_vit.png";
            break;
          case 7:
            cabecalhoImg = "cabe_pp_receita.png";
            rodapeImg = "rodape_pp.png";
            break;
          default:
            cabecalhoImg = "cabe_cmr_receita.png";
            rodapeImg = "rodape_cmr.png";
        }

        // Formata data
        const mData = new Date(data.dataCadastro);
        const dataFormatada = [
          String(mData.getDate()).padStart(2, "0"),
          String(mData.getMonth() + 1).padStart(2, "0"),
          mData.getFullYear()
        ].join('/');

        // Objeto final
        const receituario = {
          paciente: this.mFicha.nomePaciente,
          solicitante: `Dr(a). ${this.user.nome}`,
          os: this.mFicha.idOrdemServico,
          atendimento: this.mFicha.idAtendimento,
          medicamentos: [],
          descricao: "",
          dataConsulta: dataFormatada,
          receita: base64Pure,
          crm: `${this.user.siglaConselho}/${this.user.ufConselho} - ${this.user.crm}`,
          tipo: "solicitacaoRelatorio",
          cabecalhoImg,
          rodapeImg
        };

        // Envia para o backend
        const response = await medicoService.medico.downloadRelatorioReceita(receituario);

        await this.prepararVisualizacaoPdf(response.data);

      } catch (error) {
        console.error("Erro ao gerar relatório:", error);
        throw error;
      } finally {
        this.loadDownload = false;
      }
    },

    async gerarComHtml2Canvas() {
      // Atualiza o conteúdo do relatório
      this.prepararConteudoPorTipo();
      
      // Aguarda o DOM ser atualizado
      await this.$nextTick();

      // Evita bloqueio de pop-up abrindo a aba antes das operações assíncronas
      let preOpenedWindow = null;
      if (!this.isVisualizadorType) {
        preOpenedWindow = window.open('', '_blank');
      }
      
      const element = this.$refs.pdfContent;
      
      if (!element) {
        throw new Error("Elemento pdf-content não encontrado no DOM");
      }

      // Pequena pausa para garantir renderização
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Aguarda o carregamento de imagens no conteúdo
      await this.waitForImages(element);

      const canvas = await html2canvas(element, {
        scale: 2,
        width: 794,
        height: element.scrollHeight,
        useCORS: true,
        logging: true,
        backgroundColor: "#FFFFFF",
        scrollX: 0,
        scrollY: 0,
        windowWidth: 794,
        allowTaint: false,
        foreignObjectRendering: false,
        onclone: (clonedDoc) => {
          const clonedElement = clonedDoc.querySelector(`[data-pdf-content="${this.pdfContentId}"]`);
          if (clonedElement) {
            clonedElement.style.color = '#000000';
            clonedElement.style.backgroundColor = '#FFFFFF';
            const allElements = clonedElement.getElementsByTagName('*');
            for (let el of allElements) {
              el.style.color = '#000000';
              el.style.backgroundColor = '#FFFFFF';
            }
          }
        }
      });

      const imageBase64 = canvas.toDataURL("image/png", 1.0);
      const base64Pure = imageBase64.split(",")[1];

      const { cabecalhoImg, rodapeImg } = this.obterImagensCabecalhoRodape();
      const dataFormatada = this.formatarData(this.dataCadastro);

      // Preparar dados baseados no tipo de impressão
      const receituario = {
        paciente: this.mFicha.nomePaciente || "Paciente não informado",
        solicitante: `Dr(a). ${this.user.nome || "Médico não informado"}`,
        os: this.mFicha.idOrdemServico || "N/A",
        atendimento: this.mFicha.idAtendimento || "N/A",
        crm: `${this.user.siglaConselho || ""}/${this.user.ufConselho || ""} - ${this.user.crm || ""}`,
        dataConsulta: dataFormatada,
        tipo: this.tipoDocumento,
        cabecalhoImg,
        rodapeImg,
      };

      // Adicionar campos específicos baseados no tipo
      if (this.tipoImpressao === "receita") {
        receituario.medicamentos = this.medicamentos || [];
        receituario.descricao = "";
        receituario.receita = base64Pure;
        receituario.exames = [];
      } else if (this.tipoImpressao === "solicitacao" || this.tipoImpressao === "solicitacao-laboratorio") {
        // Para solicitação - CORREÇÃO: usar base64Pure como receita
        const solicitacao = this.prepararSolicitacao();
        receituario.exames = solicitacao;
        receituario.medicamentos = this.receitas || [];
        receituario.receita = base64Pure; // CORREÇÃO AQUI
        receituario.descricao = this.descricao || "";
      } else if (this.tipoImpressao === "relatorio") {
        // Para relatório
        receituario.medicamentos = [];
        receituario.descricao = "";
        receituario.receita = base64Pure;
        receituario.exames = [];
      } else if (this.tipoImpressao === "laudo") {
        // Para laudo
        receituario.medicamentos = [];
        receituario.descricao = "";
        receituario.receita = base64Pure;
        receituario.exames = [];
      }

      const logPayload = {
        ...receituario,
        receita: receituario.receita ? `[base64:${receituario.receita.length}]` : ''
      };
      const reportMap = {
        receita: 'receitasmv2',
        relatorio: 'relatoriosmv2',
        solicitacao: 'solicitacaosmv2',
        'solicitacao-laboratorio': 'solicitacaosmv2'
      };
      const reportName = reportMap[this.tipoImpressao];
      let response;

      if (reportName) {
        const selectedItem = this.tipoImpressao === 'receita'
          ? this.receita
          : (this.tipoImpressao === 'relatorio' ? this.relatorio : this.solicitacao);
        const dataExibir = this.getDataExibirFallback(
          this.dataExibirValue ||
          this.formatDatePtBr(
            this.tipoImpressao === 'receita'
              ? (selectedItem?.dataSelecionada ||
                selectedItem?.dataPrescricao ||
                selectedItem?.dataReceita ||
                selectedItem?.dataCadastro ||
                selectedItem?.data)
              : (selectedItem?.dataISO ||
                selectedItem?.dataSelecionada ||
                selectedItem?.dataCadastro ||
                selectedItem?.data)
          )
        );
        const reportPayload = {
          idRelatorio: this.tipoImpressao === 'relatorio' ? selectedItem?.id : undefined,
          idReceitaMedica: this.tipoImpressao === 'receita' ? selectedItem?.idReceitaMedica : undefined,
          idSolicitacao: this.isSolicitacaoType ? selectedItem?.idSolicitacao : undefined,
          idapicfm_especializacao: this.idapicfmEspecializacao ?? selectedItem?.idapicfm_especializacao ?? 0,
          data_exibir: dataExibir,
          report: reportName,
          reportType: 'pdf'
        };
        Object.keys(reportPayload).forEach((key) => {
          if (reportPayload[key] === undefined) {
            delete reportPayload[key];
          }
        });
        console.log('[printPreview] POST /smi/reports/get payload:', {
          ...reportPayload,
          receita: logPayload.receita
        });
        response = await medicoService.medico.downloadReport(reportPayload);
      } else {
        console.log('[printPreview] POST Relatorio/rest/atendimento/receita payload:', logPayload);
        response = await medicoService.medico.downloadRelatorioReceita(receituario);
      }
      
      if (this.isVisualizadorType) {
        await this.prepararVisualizacaoPdf(response.data);
      } else {
        // Para outros tipos (apenas laudos), abrir diretamente em nova aba
        this.abrirPdf(response.data, preOpenedWindow);
      }
      
      this.showMessage(`${this.tituloDocumento} gerada com sucesso!`, "success");
    },

    async prepararVisualizacaoPdf(pdfData) {
      this.pdfBlob = new Blob([pdfData], { type: "application/pdf" });

      if (this.pdfDownloadUrl) {
        URL.revokeObjectURL(this.pdfDownloadUrl);
      }
      this.pdfDownloadUrl = URL.createObjectURL(this.pdfBlob);

      try {
        this.pdfSource = await this.blobToDataUrl(this.pdfBlob);
      } catch (error) {
        console.error("Falha ao converter PDF para data URL, usando Blob URL:", error);
        this.pdfSource = this.pdfDownloadUrl;
      }

      this.showPdfViewer = true;
      this.page = 1;
    },

    blobToDataUrl(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    abrirPdf(pdfData, preOpenedWindow = null) {
      const url = window.URL.createObjectURL(new Blob([pdfData], { type: "application/pdf" }));
      const targetWindow = preOpenedWindow && !preOpenedWindow.closed
        ? preOpenedWindow
        : window.open('', '_blank');
      if (!targetWindow) return;
      targetWindow.location = url;
    },


    prepararSolicitacao() {
      const solicitacao = [];
      const items = this.medicamentos || [];
      
      for (let i = 0; i < items.length; i++) {
        const e = items[i];
        const item = {
          ...e,
          nome: e.apelido || e.nome || `Exame ${i + 1}`
        };
        solicitacao.push(item);
      }
      return solicitacao;
    },

    obterImagensCabecalhoRodape() {
      let cabecalhoImg, rodapeImg;
      const isSolicitacao = this.tipoImpressao === "solicitacao" || this.tipoImpressao === "solicitacao-laboratorio";
      
      switch (this.user.idEmpresa) {
        case 4:
          cabecalhoImg = isSolicitacao ? "cabe_cmr_exame.png" : "cabe_cmr_receita.png";
          rodapeImg = "rodape_cmr.png";
          break;
        case 1:
          cabecalhoImg = isSolicitacao ? "cabe_vit_exame.png" : "cabe_vit_receita.png";
          rodapeImg = "rodape_vit.png";
          break;
        case 7:
          cabecalhoImg = isSolicitacao ? "cabe_pp_exame.png" : "cabe_pp_receita.png";
          rodapeImg = "rodape_pp.png";
          break;
        default:
          cabecalhoImg = isSolicitacao ? "cabe_cmr_exame.png" : "cabe_cmr_receita.png";
          rodapeImg = "rodape_cmr.png";
          break;
      }
      
      return { cabecalhoImg, rodapeImg };
    },

    formatarData(dataString) {
      if (!dataString) {
        return '';
      }

      if (dataString instanceof Date) {
        return isNaN(dataString.getTime()) ? '' : dataString.toLocaleDateString('pt-BR');
      }

      if (typeof dataString === 'string' && dataString.includes('/')) {
        const [dia, mes, ano] = dataString.split('/');
        if (dia && mes && ano) {
          const date = new Date(Number(ano), Number(mes) - 1, Number(dia));
          return isNaN(date.getTime()) ? '' : date.toLocaleDateString('pt-BR');
        }
      }
      
      try {
        const date = new Date(dataString);
        return isNaN(date.getTime()) ? '' : date.toLocaleDateString('pt-BR');
      } catch (error) {
        return '';
      }
    },

    waitForImages(element) {
      return new Promise((resolve) => {
        const images = element.getElementsByTagName('img');
        if (images.length === 0) {
          resolve();
          return;
        }

        let loadedCount = 0;
        const totalImages = images.length;

        const imageLoaded = () => {
          loadedCount++;
          if (loadedCount === totalImages) {
            resolve();
          }
        };

        Array.from(images).forEach(img => {
          if (img.complete) {
            imageLoaded();
          } else {
            img.onload = imageLoaded;
            img.onerror = imageLoaded;
          }
        });
      });
    },


    printPdf() {
      if (!this.pdfBlob) {
        this.showMessage('Nenhum PDF disponível para impressão.', 'warning')
        return
      }

      const url = URL.createObjectURL(this.pdfBlob)
      const iframe = document.createElement('iframe')
      iframe.style.position = 'fixed'
      iframe.style.right = '0'
      iframe.style.bottom = '0'
      iframe.style.width = '0'
      iframe.style.height = '0'
      iframe.style.border = '0'
      iframe.src = url

      const cleanup = () => {
        setTimeout(() => {
          document.body.removeChild(iframe)
          URL.revokeObjectURL(url)
        }, 1000)
      }

      iframe.onload = () => {
        try {
          iframe.contentWindow?.focus()
          iframe.contentWindow?.print()
        } catch (error) {
          console.error('Erro ao tentar imprimir o PDF:', error)
          this.showMessage('Não foi possível iniciar a impressão automaticamente.', 'error')
        } finally {
          cleanup()
        }
      }

      iframe.onerror = () => {
        this.showMessage('Erro ao carregar o PDF para impressão.', 'error')
        cleanup()
      }

      document.body.appendChild(iframe)
    },

    fecharVisualizador() {
      this.showPdfViewer = false;
      this.pdfSource = null;
      if (this.pdfDownloadUrl) {
        URL.revokeObjectURL(this.pdfDownloadUrl);
        this.pdfDownloadUrl = null;
      }
      this.pdfBlob = null;
    },

    showMessage(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    }
  }
};
</script>

<style scoped>
#pdf-content {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #000000 !important;
}

#pdf-content >>> * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color: inherit !important;
}

#pdf-content >>> h1, 
#pdf-content >>> h2, 
#pdf-content >>> h3 {
  margin-bottom: 16px;
  color: #000000 !important;
}

#pdf-content >>> p {
  margin-bottom: 12px;
  color: #000000 !important;
}

#pdf-content >>> div {
  color: #000000 !important;
}

#pdf-content >>> span {
  color: #000000 !important;
}
</style>
